import React from 'react'
import { Row, Col } from 'antd'
import DetailsWithPhoto from 'components/shared/DetailsWithPhoto'
// import PropTypes from 'prop-types'

export default function AboutCalculator({ calculatorData }) {
  const { description, image } = calculatorData.attributes
  return (
    <Row className="page-wrapper">
      <Col
        md={16}
        xs={24}
        style={{
          fontWeight: 'normal',
          fontSize: '16px',
          lineHeight: '22px',
        }}
      >
        <DetailsWithPhoto details={description} image={image} />
      </Col>
    </Row>
  )
}

// AboutCalculator.propTypes = {
//   calculatorData: PropTypes.shape({
//     name: PropTypes.string.isRequired,
//     description: PropTypes.string.isRequired,
//   }).isRequired,
// }
